import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var userMessageRoute = [{
  path: "user-message",
  name: "user-message",
  component: function component() {
    return import( /* webpackChunkName: "login" */"./user-message.vue");
  }
}];